import pt from './pt';

const i18n = {
  getMessage: text => {
    const translatedText = pt[text];
    return translatedText || text;
  },
};

export default i18n;
